/* eslint-disable */

$('#filterITSDS').change(function() {

  var option = $(this).find("option:selected").val();
  var $container = $('#filterITSDSContainer');

  $('.loader-container').fadeIn();
  $container.empty();

  if( option == 'date' ) {
    $.ajax({
      type       : "GET",
      data       : { 
        dataType   : "jsonp",
        action:'ajax_itsds_date',
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        if(data.length) {
          pageNumber++;
          data = JSON.parse(data);
          var totalPages = data[0];
          var content = data[1];
          $('.loader-container').fadeOut();
          $(content).hide().appendTo($container).fadeIn();

          if (pageNumber < totalPages) {
            $('.moreitsdsposts').fadeIn();
            $('.moreitsdsposts').empty().append('<div>Load more projects</div>');
          }
        }
      },
    });
  }

  if( option == 'agency' ) {
    $.ajax({
      type       : "GET",
      data       : { 
        dataType   : "jsonp",
        action:'ajax_itsds_agency',
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        if(data.length) {
          pageNumber++;
          data = JSON.parse(data);
          var totalPages = data[0];
          var content = data[1];
          $('.loader-container').fadeOut();
          $(content).hide().appendTo($container).fadeIn();

          if (pageNumber < totalPages) {
            $('.moreitsdsposts').fadeIn();
            $('.moreitsdsposts').empty().append('<div>Load more projects</div>');
          }
        }
      },
    });
  }

  if( option == 'all' ) {
    $.ajax({
      type       : "GET",
      data       : { 
        dataType   : "jsonp",
        action:'ajax_itsds_all',
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        $('.loader-container').fadeOut();
        if(data.length) {
          var content = data;
          $container.empty();
          $(content).hide().appendTo($container).fadeIn();
        }
      },
    });
  }
});

// AJAX on load

$('.moreitsdsposts').click(function() {
  var option = $('#filterITSDS').find("option:selected").val();
  var $container = $('#filterITSDSContainer');

  jQuery.ajax({
      type       : "GET",
      data       : {
        page: pageNumber,
        option: option,
        dataType   : "jsonp",
        action:'ajax_itsds_load_more',
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        pageNumber++;
        if(data.length) {
          data = JSON.parse(data);
          var totalPages = data[0];
          var content = data[1];
          $(content).hide().appendTo($container).fadeIn();

          if (pageNumber < totalPages) {
            $('.moreitsdsposts').fadeIn();
            $('.moreitsdsposts').empty().append('<div>Load more projects</div>');
          }
        }
      },
    });
  });


// WEBPACK FOOTER //
// ./scripts/routes/itsds-projects.js